<template>
  <component
    :is="rootComponent"
    class="baseImg"
    @show="handleImage">
    <van-image
      v-if="image"
      :fit="fit"
      :width="width"
      :height="height"
      :src="image"
      :show-loading="showLoading"
      :style="{...ratioStyle}"
      :round="round"
      v-on="$listeners">
      <template v-slot:loading>
        <img
          class="exImg"
          :src="require('../assets/images/home/loading.gif')"/>
      </template>
      <template v-slot:error>
        <img
          class="exImg"
          :src="errorImage"/>
      </template>
    </van-image>
  </component>
</template>

<script>
import { imgToBase64 } from '../API/common'

export default {
  name: 'baseImage',
  components: {
    emptyComponent: {
      template: '<div><slot/></div>',
      mounted () {
        this.$emit('show')
      }
    }
  },
  props: {
    type: String,
    url: String,
    encrypt: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '0'
    },
    fit: {
      type: String
    },
    showLoading: {
      type: Boolean,
      default: true
    },
    round: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: true
    },
    // 圖片寬高比例 -> 寬 / 高
    ratio: Number
  },
  data () {
    return {
      image: null,
      errorImage: require('../assets/images/image-error.png')
    }
  },
  computed: {
    rootComponent () {
      return this.lazy ? 'lazy-component' : 'empty-component'
    },
    /**
     * 用來讓圖片依照寬度來自適應
     * https://www.zhangxinxu.com/wordpress/2017/08/css-percent-padding-image-layout/
     */
    ratioStyle () {
      const ratio = this.ratio || 1

      return { paddingBottom: `${100 / ratio}%` }
    }
  },
  watch: {
    url (newUrl, oldUrl) {
      this.handleImage()
    }
  },
  methods: {
    handleImage () {
      if (this.encrypt) {
        if (this.url === null) {
          console.warn('[Tip]: Prop "url" is "null". It is recommended to use "undefined" in `encrypt` mode for initial component.')
          this.image = ''
        } else if (this.url) {
          imgToBase64(this.url, this.type).then(res => {
            this.image = res === '' ? this.errorImage : res
          })
        }
      } else {
        this.image = this.url
      }
    }
  }
}
</script>

<style scoped>
.exImg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.baseImg >>> .van-image__loading,
.baseImg >>> .van-image__error {
  background-color: transparent;
}

.baseImg >>> .van-image__img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/baseImage.vue